import Boundary from './Boundary.js';
import { getOSM } from '../OverworldAnimation.js';

export default class LandEntryZone extends Boundary {
    serialize() {
        console.log(`Serializing ${this.constructor.name}`);
        return {
            position: this.position,
        };
    }

    static deserialize(data) {
        return new LandEntryZone({ position: data.position });
    }

    constructor({ position }) {
        super({ position });
        this.interactionPriority = 8;
    }

    entered() {
        const playerPosition = getOSM().player.position;
        return playerPosition.x === this.position.x && playerPosition.y === this.position.y;
    }
}
